import { DataSourceFactory } from 'app/components';

interface IUserActivity {
  userName: string;
  action: string;
  message: string;
  activityDate: string;
}

const getUserActivityDataSource = (apiKey: string) => {
  return DataSourceFactory.create<IUserActivity>({
    transport: {
      read: {
        url: 'https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/user-activity',
        request: {
          method: 'POST',
          headers: new Headers({
            Authorization: apiKey,
          }),
        },
      },
    },
  });
};

export { IUserActivity, getUserActivityDataSource };



// WEBPACK FOOTER //
// ./src/app/containers/UserActivity/DataSource.ts